"use strict";

import { Html5Qrcode } from "html5-qrcode";
const alertMessage = require('../utils/alertMessage');

let html5QrCode;
let notAllowedMsg = '';
let inUseMsg = '';
let generalErrMsg = '';

function startScanning() {
    html5QrCode = new Html5Qrcode("reader");

    Html5Qrcode.getCameras().then(cameras => {
      
        html5QrCode.start(
            { facingMode: { exact: "environment" } },
            {
                fps: 10,
                qrbox: { width: 250, height: 250 }
            },
            qrCodeMessage => {
                $('#storeAppSearchForm #searchInput').val(qrCodeMessage);
                $('#storeAppSearchForm .js-search-customer-btn').removeAttr('disabled');
                $('#storeAppSearchForm .js-search-customer-btn').trigger('click')
                alert(`QR Code Scansionato: ${qrCodeMessage}`);
                html5QrCode.stop().then(ignore => {}).catch(err => {
                    alertMessage(err, 'cc-alert--danger');
                });
            },
            errorMessage => {
                console.error(`Error during scanning: ${errorMessage}`);
            }
        ).catch(err => {
            console.error(`Error during scanner initialization: ${err}`);
        });
    }).catch(err => {
        console.error(`Error when obtaining cameras: ${err}`);
        if(err.toString().includes('NotReadableError')){
            alertMessage(inUseMsg, 'cc-alert--danger');
            return
        } 
        if(err.toString().includes('NotAllowedError')){
            alertMessage(notAllowedMsg, 'cc-alert--danger');
            return
        } 
        alertMessage(generalErrMsg, 'cc-alert--danger');
    });
}

$(document).ready(function() {
    
    $('body').on('click', '.js-qrcode-app', function () {
        notAllowedMsg = $(this).data('notallowed');
        inUseMsg = $(this).data('inuse');
        generalErrMsg = $(this).data('generalerror');
        startScanning();
    });

    $('#clerkService').on('hidden.bs.modal', function () {
        
        if (html5QrCode) {
            html5QrCode.stop().then(ignore => {
                html5QrCode.clear();
            }).catch(err => {
                console.error(err);
            });
        }
    });
});